import { render } from "./Content.vue?vue&type=template&id=03817f9c"
const script = {}

import exportComponent from "D:\\ARCHIVOS\\PROYECCION SERVIDOR\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__